import { CounterpartyTinAccessAction } from "@common/types/counterpartyTin";
import { APIProcessName } from "../process-names";

export interface TinAccessHistorySource {
    sourceType: APIProcessName;
    action: CounterpartyTinAccessAction;
}

export const TIN_ACCESS_HISTORY_SOURCES: readonly TinAccessHistorySource[] = [
    {
        sourceType: APIProcessName.COUNTERPARTY_TIN_REVEAL,
        action: CounterpartyTinAccessAction.REVEAL_COMPLETED,
    },
    {
        sourceType: APIProcessName.COUNTERPARTY_TIN_EXPORT,
        action: CounterpartyTinAccessAction.EXPORT_COMPLETED,
    },
];

const TIN_ACCESS_HISTORY_SOURCE_TYPES: ReadonlySet<string> = new Set(
    TIN_ACCESS_HISTORY_SOURCES.map(({ sourceType }) => sourceType),
);

export const isTinAccessHistorySourceType = (sourceType: string): boolean =>
    TIN_ACCESS_HISTORY_SOURCE_TYPES.has(sourceType);
